import React from "react";

import IsRequired from "../../../LeadCompliance/components/Table/IsRequired";
import Report from "./Report";

function MiceRats({ params, refetchUnits }) {
  const { compliance } = params.row;
  const isRequired = compliance?.visible_mice || compliance?.visible_rats;

  return compliance?.status == "pending" ? (
    ""
  ) : (
    <IsRequired
      required={isRequired}
      attachment={compliance?.ll55_visible_mices_and_rates_report}
    >
      <Report
        id={compliance.ll55_id}
        attachment={compliance?.ll55_visible_mices_and_rates_report}
        refetchUnits={refetchUnits}
        status={"Report-Needed"}
        type={"mice/rats"}
      />
    </IsRequired>
  );
}

export default MiceRats;
